// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addProductReviewStyle_invalidDataError__rETmE"};